import { customStyleSelect } from "../../../classes/consts";
import "./index.css";
import Select from "react-select";

export default function SelectSearchable({options, state, setState, name, placeholder, isMulti, getFunctionOnChange}){
    function checkSelectTypeAndInsert(value){
        console.log("Passou aqui")
        if(isMulti){
            return setState((prevState) => ({...prevState, [name]: value}));
        }

        return setState((prevState) => ({...prevState, [name]: {label: value.label, value: value.value}}));
    }

    function checkIfInputValueNonIsEmptyAndInsert(e){
        if(e){
            setState((prevState) => ({...prevState, [name]: {label: e, value: ""}}));
        }
    }

    function checkIfIsChangingSelectedState(event){
        if(event.code === "Backspace" || event.code === "Delete"){
            setState((prevState) => ({...prevState, [name]: {label: "", value: ""}}));
        }
    }
    
    return (
        <Select
            onInputChange={(e) => {
                checkIfInputValueNonIsEmptyAndInsert(e);
                if(getFunctionOnChange){
                    getFunctionOnChange(e, name);
                }
            }}
            onKeyDown={checkIfIsChangingSelectedState} 
            value={state}
            options={options} 
            name={name}
            onChange={checkSelectTypeAndInsert}
            placeholder={placeholder}
            styles={customStyleSelect} 
            className="select-searchable" 
            isMulti={isMulti}
        >

        </Select>
    )
}